<template>
  <div class="modules-content" style="margin-top:0px;">
    <div class="module-item" data-id="1" data-module-lessons="23">
      <div class="title-content custom-grid">
        <h3 class="module-title" style="font-size: 14px;">
          Pagamentos
          <i class="icon icon-alert-circle-i"></i>
          <div class="module-description-tooltip">Pagamentos</div>
        </h3>

        <span class="module-progress loading-placeholder" style="display: block;">
          <div v-if="userType==0" class="control-group">
            <select v-model="selectedStudent" id="student" class="form-control">
              <option value="0" disabled selected>Escolha um aluno</option>
              <option v-for="u in users" v-bind:key="u.id" v-bind:value="u.id">{{u.name}}</option>
            </select>
          </div>
        </span>

        <span class="module-progress loading-placeholder" style="display: block;"></span>

        <span class="module-progress loading-placeholder" style="display: block;">
          <lms-button
            style="margin-right:5px;"
            @click="getPaymentData"
            :loading="loadingData"
          >Filtrar</lms-button>
          <lms-button
            class="btn-danger"
            @click="selectedCourse = 0; selectedStudent = null;"
            :loading="loadingData"
          >Limpar</lms-button>
        </span>
      </div>

      <li class="lesson-subtitle"  style=" grid-template-columns:1.5fr 22rem  10rem 1.25fr 1.25fr .75fr;">
        <span class="lesson-title">Id</span>
        <span class="lesson-title">Usuário</span>
        <span class="lesson-title">Produtos</span>
        <span class="lesson-title">Criação</span>
        <span class="lesson-title">Última atualização</span>
        <span class="lesson-status">Status</span>

        <!-- <span class="lesson-option"></span> -->
      </li>

      <ul class="lessons-list">
        <li
        style="grid-template-columns:1.5fr 22rem  10rem 1.25fr 1.25fr .75fr;"
          v-for="(data,index) in paymentData"
          :key="index"
          class="lesson"
          data-id="64"
          data-videos="1"
        >
          <span class="lesson-title">{{data.id}}</span>
          <span class="lesson-title">{{data.userName}}</span>
          <span class="product-title">
            {{data.products.length}} produtos
            <div class="products-description-tooltip">
              <p v-for="p in data.products" :key="p.id">{{p.name}}</p>
            </div>
          </span>


          <span class="lesson-title">{{data.creationDate}}</span>
          <span class="lesson-title">{{data.lastUpdate}}</span>

          <span v-if="data.status == 3" class="lesson-status" style="display: flex;">
            <span class="lesson-status finished loading-placeholder">
              <span class="icon icon-c-check"></span> Pago
            </span>
          </span>
          <span v-else class="lesson-status" style="display: flex;">
            <span class="lesson-status in-progress loading-placeholder">
              <i class="material-icons">error_outline</i>Não pago
            </span>
          </span>

          <!-- <span class="lesson-option">
                <a href="/aluno/turma/19/aula/64/" style="font-size: 14px;">Detalhes</a>
          </span>-->
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.product-title {
				position: relative;
					display: flex;
					flex-direction: row;
					align-items: center;
					&:hover {
						cursor: pointer;
						.products-description-tooltip {
							display: block;
						}
          }
}
.products-description-tooltip {
						z-index: 10;
						display: none;
						width: 20rem;
						position: absolute;
						top: 4.5rem;
						background: #444;
						color: #fff;
						padding: 1rem;
						border-radius: .25rem;
						font-weight: normal;
						left: 0;
					}
</style>

<script>
import axios from "axios";

export default {
  props: {
    users: {
      type: Array,
      required: true
    },
    paymentData: {
      type: Array,
      required: true
    },
    loadingData: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      userType: this.$store.getters.user.type,
      selectedStudent: 0
    };
  },
  components: {},
  methods: {
    getPaymentData() {
      this.$emit("getPaymentData", this.selectedStudent);
    }
  },
  created() {}
};
</script>
